import type { FeedbackReasonOption, OutputFeedbackValue } from "./types";

export const NEGATIVE_FEEDBACK_REASONS: FeedbackReasonOption[] = [
  { id: "incorrect_data_or_calculation", label: "Wrong or outdated data" },
  { id: "wrong_or_missing_sources", label: "Wrong or missing sources" },
  { id: "failed_or_slow", label: "Too slow or didn’t finish" },
  { id: "didnt_follow_instructions", label: "Didn’t do what I asked" },
  {
    id: "hard_to_use_or_poorly_presented",
    label: "Poorly formatted or presented",
  },
];

export const POSITIVE_FEEDBACK_REASONS: FeedbackReasonOption[] = [
  { id: "accurate", label: "Accurate" },
  { id: "up_to_date", label: "Up to date" },
  { id: "good_sources", label: "Good sources" },
  { id: "complete", label: "Complete" },
  { id: "followed_instructions", label: "Followed instructions" },
  { id: "clear_and_useful", label: "Clear and useful" },
];

export const FEEDBACK_REASONS_BY_VALUE: Record<OutputFeedbackValue, FeedbackReasonOption[]> = {
  positive: POSITIVE_FEEDBACK_REASONS,
  negative: NEGATIVE_FEEDBACK_REASONS,
};

export const THANK_YOU_MESSAGE = "Thank you for your feedback!";
export const FEEDBACK_DIALOG_TITLE = "Share feedback";
export const FEEDBACK_DIALOG_DESCRIPTION = "Select all that apply.";
export const FEEDBACK_FAILURE_MESSAGE = "Something went wrong. Please try again.";

/** How long the inline confirmation stays visible after a rating. */
export const THANK_YOU_DURATION_MS = 4000;
